module.exports = __webpack_public_path__ + "static/6013-San-Bernard-Front-768x332-602d8d47a398ea834b11eb1c9620e685.jpg";